<template src='./dropdown-grade.html' ></template>
<style lang="less" src="./dropdown-grade.less"></style>

<script>

 import { mapState, mapActions } from 'vuex'
const tipoGradePrimaria = 1;
const Grade = "Grade";
const DetalhesDoProduto = 'DetalhesDoProduto';

	export default {
        name: 'dropdown',

        props:{
            tipoDaGrade : Number
        },

        computed:{
            ...mapState(Grade, [
                'gradePrimaria', 'gradeSecundaria', 
                'gradePrimariaSelecionadaId', 'gradeSecundariaSelecionadaId'
            ]),
             ...mapState(DetalhesDoProduto, ['produto']),

             grades(){
                 return (this.tipoDaGrade === tipoGradePrimaria ? this.gradePrimaria : this.gradeSecundaria) || [] ;
             }
        },
        methods:{
            ...mapActions(Grade, ['getGrades', 'limparGrades', 'selecionarGrade']),
            changeGrade(ev) {
                this.selecionarGrade({ 
                    idGrade: ev?.target?.value, 
                    tipoGrade: this.tipoDaGrade 
                });
            }
        },
        created(){

            this.getGrades({ idProduto: this.produto.id, tipoGrade: this.tipoDaGrade });
           
        },
        beforeDestroy(){
            this.limparGrades();
        }
		
	}
</script>